// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import VueCookies from 'vue-cookies';
import App from './App';
import router from './router';
import { app, Account, ShoppingCart, Location, Merchant } from './functions.js';

import AccountAPI from './api/account.js';

Vue.config.productionTip = false
Vue.use(VueCookies, { expires: '30d'})

Vue.filter('currencyFormat', function (value) {
  if (typeof value !== 'number') {
    if(typeof value == 'string')
    {
      if(value == '')
      {
        return value;
      }
      else
      {
        let isnum = /^\d*\.?\d*$/.test(value);
        if(isnum)
        {
          value = parseFloat(value);
        }
        else
        {
          return value;
        }
      }
    }
    else
    {
      return value
    }
  }
  var formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: app.active_currency.code,
    minimumFractionDigits: app.active_currency.decimal_digits
  })
  return formatter.format(value)
})

Vue.filter('weightFormat', function (value) {
  if (typeof value !== 'number') {
    if(typeof value == 'string')
    {
      if(value == '')
      {
        return value;
      }
      else
      {
        let isnum = /^\d*\.?\d*$/.test(value);
        if(isnum)
        {
          value = parseFloat(value);
        }
        else
        {
          return value;
        }
      }
    }
    else
    {
      return value
    }
  }
 
  return (value / 1000).toString() + ' kg';
})

 // Load Location Session
if (JSON.parse(sessionStorage.getItem('gsm_al'))) {
  var session_location = JSON.parse(sessionStorage.getItem('gsm_al'));
  Location.setLocation(session_location);
}

 // Load Merchant Session
if (JSON.parse(sessionStorage.getItem('gsm_m'))) {
  var session_merchant = JSON.parse(sessionStorage.getItem('gsm_m'));
  Merchant.setMerchant(session_merchant);
}

 // Load Cart Session
ShoppingCart.active_shopping_cart = (JSON.parse(sessionStorage.getItem('gsm_a_sc')) == undefined || JSON.parse(sessionStorage.getItem('gsm_a_sc')) == null ? 0 : JSON.parse(sessionStorage.getItem('gsm_a_sc')))
ShoppingCart.cart = (JSON.parse(sessionStorage.getItem('gsm_sc')) ? JSON.parse(sessionStorage.getItem('gsm_sc')) : [{
  recipient: null,
  products: []
}])


// Load Account Session
if (JSON.parse(sessionStorage.getItem('gsm_at'))) {
  var session_account = JSON.parse(sessionStorage.getItem('gsm_at'));

  if(session_account.login_id == '' || session_account.token == '' || session_account.customer_id == '')
  {
      console.log("Invalid Session Data");
      if(session_account.customer_id != '')
      {
          Account.setCustomerID(session_account.customer_id);
      }
  }
  else
  {
      Account.setToken(session_account.token);
      Account.setLoginId(session_account.login_id);
      Account.setCustomerID(session_account.customer_id);
      Account.setPasswordStatus(session_account.temp_password);

      var backend_session_request = AccountAPI.ping(session_account.login_id, session_account.token);
      backend_session_request.then((backend_session)=>{
        if(backend_session.status == "success")
        {
          // Load Account Info
          var account_details = null;
          var account_info_request = AccountAPI.accountInfo(session_account.token, session_account.customer_id);
          account_info_request.then((response) =>{
              account_details = response.data;
          })
          .then((response)=>{

              // Check Default Address. 
              // var default_address = null;
              // var barangay_code = '';
              // account_details.addresses.forEach((address, address_index) => {
              //   if(address.is_default == true)
              //   {
              //     default_address = address;
              //   }
              // });


              // If there's a default address, overwrite Location Session if existing
              // if(default_address)
              // {
              //   Location.location.barangay.brgy_code = default_address.brgy.brgyCode;
              //   Location.location.barangay.brgy_name = default_address.brgy.brgyDesc;
              //   Location.location.city.city_code = default_address.citymun.citymunCode;
              //   Location.location.city.city_name = default_address.citymun.citymunDesc;
              //   Location.location.province.province_code = default_address.prov.psgcCode;
              //   Location.location.province.province_name = default_address.prov.provDesc;
              //   Location.setLocation(Location.location);
              // }
              

              // Load Account Cart
              // barangay_code = (default_address == null ? Location.location.barangay.brgy_code : default_address.brgy.brgyCode);

                // Checnged Login ID to Custoemr ID 07/18/2023
              var account_cart_request = AccountAPI.myCart(session_account.customer_id, session_account.token, Location.location.barangay.brgy_code, true);
              account_cart_request.then((account_cart) => {
                 if(account_cart.status == "success")
                {
                    var cart = account_cart.cart;
                    cart.forEach((product,product_index)=>{
                        var x = ShoppingCart.addToCart(product, product.quantity);
                        x.then((add_to_cart)=>{
                        });
                    });
                }
              });

          });
        }
        else
        {
          // Reset Token From Session
          Account.setToken('');
          Account.setLoginId('');
          Account.setCustomerID('');
        }
      });
  }
}
if(JSON.parse(sessionStorage.getItem('gsm_aa')))
{
   var session_account_address = JSON.parse(sessionStorage.getItem('gsm_aa'));
    Account.setAddresses(session_account_address);
}
if(JSON.parse(sessionStorage.getItem('gsm_ai')))
{
   var session_account_info = JSON.parse(sessionStorage.getItem('gsm_ai'));
    Account.setInfo(session_account_info);
}


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js